import { mapState, mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
import api from '@/services/apiService';
export default {
  name: 'WidgetTwinMapOptionsEditor',
  props: {
    value: {
      type: Object,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tilesets: [],
      isUploading: false,
      isFetchingTilesets: false
    };
  },
  computed: {
    ...mapGetters({
      isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
    }),
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    interactive: {
      get() {
        const clone = cloneDeep(this.value);
        return get(clone, 'twinMapOptions.interactive', false);
      },
      set(val) {
        const clone = cloneDeep(this.value);
        set(clone, 'twinMapOptions.interactive', val);
        this.$emit('input', clone);
      }
    },
    tilesetIds: {
      get() {
        return get(this.value, 'twinMapOptions.tilesetIds', []);
      },
      set(val) {
        const clone = cloneDeep(this.value);
        set(clone, 'twinMapOptions.tilesetIds', val);
        this.$emit('input', clone);
      }
    },
    maxZoom: {
      get() {
        const clone = cloneDeep(this.value);
        return get(clone, 'twinMapOptions.maxZoom', 15);
      },
      set(val) {
        const clone = cloneDeep(this.value);
        if (val === '' || val === undefined) {
          val = 15;
        }
        if (val !== null) {
          if (val < 0) {
            val = 0;
          }
          if (val > 15) {
            val = 15;
          }
        }
        set(clone, 'twinMapOptions.maxZoom', val);
        this.$emit('input', clone);
      }
    },
    clusterRadius: {
      get() {
        const clone = cloneDeep(this.value);
        return get(clone, 'twinMapOptions.clusterRadius', 25);
      },
      set(val) {
        const clone = cloneDeep(this.value);
        if (val === '' || val === undefined) {
          val = 25;
        }
        if (val !== null) {
          if (val < 0) {
            val = 0;
          }
          if (val > 150) {
            val = 150;
          }
        }
        set(clone, 'twinMapOptions.clusterRadius', val);
        this.$emit('input', clone);
      }
    },
    maxZoomItems() {
      const options = [0, 3, 4, 6, 10, 15];
      return options.map(option => ({
        text: this.$t(`Dashboards.components.widgetTwinMapOptionsEditor.inputs.maxZoom.options.${option}`),
        value: option
      }));
    },
    hasPopup: {
      get() {
        const clone = cloneDeep(this.value);
        return get(clone, 'twinMapOptions.hasPopup', false);
      },
      set(val) {
        const clone = cloneDeep(this.value);
        set(clone, 'twinMapOptions.hasPopup', val);
        if (val && !get(clone, 'twinMapOptions.popupTitle')) {
          set(clone, 'twinMapOptions.popupTitle', '{twin.title}');
        }
        this.$emit('input', clone);
      }
    },
    zoomingEnabled: {
      get() {
        const clone = cloneDeep(this.value);
        return !get(clone, 'twinMapOptions.zoomingDisabled', false);
      },
      set(val) {
        const clone = cloneDeep(this.value);
        set(clone, 'twinMapOptions.zoomingDisabled', !val);
        this.$emit('input', clone);
      }
    },
    shapefilesEnabled() {
      return this.isFeatureFlagEnabled('rd-7817-shapefiles');
    }
  },
  mounted() {
    if (this.shapefilesEnabled) {
      this.fetchTilesets();
    }
  },
  methods: {
    openShapefile() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.geojson,.kml';
      input.onchange = () => {
        this.uploadShapefileFile(input.files[0]);
      };
      input.click();
    },
    async uploadShapefileFile(file) {
      this.isUploading = true;
      try {
        const formData = new FormData();
        formData.append('file', file);
        await api.instanceMultipart.post('/upload/map/shapefile/geojson', formData);
        await this.fetchTilesets();
      } catch (error) {
        console.error(error);
        this.$snack(this.$t('Dashboards.components.widgetTwinMapOptionsEditor.errors.uploadShapefile', {
          error: error.message
        }), 'error');
      } finally {
        this.isUploading = false;
      }
    },
    async fetchTilesets() {
      try {
        this.isFetchingTilesets = true;
        const response = await api.instance.get('/upload/map/tilesets');
        const successfullTilesets = response.data.filter(tileset => tileset.status === 'fulfilled');
        const errorTilesets = response.data.filter(tileset => tileset.status === 'rejected');
        // show error snack for each error tileset
        errorTilesets.forEach(tileset => {
          this.$snack(this.$t('Dashboards.components.widgetTwinMapOptionsEditor.errors.fetchTilesets', {
            error: tileset.error
          }), 'error');
        });
        this.tilesets = successfullTilesets.map(tileset => ({
          ...tileset.value,
          disabled: tileset.value.upload.complete === false
        }));
        this.tilesetIds = this.tilesetIds.filter(tilesetId => this.tilesets.find(tileset => tileset.value.tileSetId === tilesetId));
        if (this.tilesets.some(tileset => tileset.upload.complete === false)) {
          setTimeout(() => {
            this.fetchTilesets();
          }, 1000);
        }
      } catch (error) {
        console.error(error);
        this.$snack(this.$t('Dashboards.components.widgetTwinMapOptionsEditor.errors.fetchTilesets', {
          error: error.message
        }), 'error');
      } finally {
        this.isFetchingTilesets = false;
      }
    }
  }
};